import gql from 'graphql-tag';
import client from '../options/apollo';

export default {
  login(payload: {
    username: string;
    password: string;
    role: string[];
    captchaKey: string;
    captchaCode: string;
  }) {
    return client.mutate({
      mutation: gql`
        mutation(
          $username: String!
          $password: String!
          $roles: [AdminRole]
          $captchaKey: String!
          $captchaCode: String!
        ) {
          result: loginWithUsernameAndPassword(
            username: $username
            password: $password
            roles: $roles
            captchaKey: $captchaKey
            captchaCode: $captchaCode
          ) {
            token: accessToken
            code
            me {
              id
              username
              nickname
              avatar
              phone
              currentAuthority: role
              # 所属国家
              country
              brandId
            }
          }
        }
      `,
      variables: payload,
      fetchPolicy: 'no-cache',
    });
  },
  // 服务商登录运营商
  loginWithServer(payload: { username: string }) {
    return client.mutate({
      mutation: gql`
        mutation($username: String!) {
          loginWithServer(username: $username) {
            accessToken
            code
            me {
              id
              username
              nickname
              avatar
              status
              phone
              role
              # 所属国家
              country
              brandId
            }
          }
        }
      `,
      variables: payload,
      fetchPolicy: 'no-cache',
    });
  },
  getCapture() {
    return client.query({
      query: gql`
        query GetCaptcha {
          result: getCaptcha
        }
      `,
      fetchPolicy: 'no-cache',
    });
  },

  // 主动退出登录清楚redis缓存信息
  clearUserLoginCache(variables: { id: string; token: string }) {
    return client.query({
      query: gql`
        query clearUserLoginCache($id: String, $token: String) {
          clearUserLoginCache(id: $id, token: $token) {
            code
            msg
          }
        }
      `,
      variables,
      fetchPolicy: 'no-cache',
    });
  },
};
